import { useAccount, useConfig } from "wagmi";
import {  useCallback, useEffect, useState } from "react";
import { readContracts } from "@wagmi/core";
import idoAbi from "../assets/abis/ido.json";
import { ido } from "../constants";

function  useW3IDO() {
  const { address } = useAccount()
  const config = useConfig()
  const [value, setValue] = useState(null)
  const [refreshTime, setRefreshTime] = useState(Date.now())

  useEffect(() => {
    const inc = setInterval(() => {
      setRefreshTime(Date.now())
    }, 6000)
    return () => clearInterval(inc)
  }, []);
  const fetch = useCallback(async () => {
    try {
      const results = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: idoAbi,
            address: ido,
            functionName: 'getdata',
            args: [address]
          }
        ]
      },[config,address])

      const isActive = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: idoAbi,
            address: ido,
            functionName: 'isActive',
            args: [address,0]
          },
          {
            abi: idoAbi,
            address: ido,
            functionName: 'isActive',
            args: [address,1]
          }
        ]
      },[config,address])
      console.log('results', Number(results[0][0]))
      console.log('isActive', isActive[0],isActive[1])
      setValue({
        joined:[ Number(results[0][0]) ,Number(results[0][3])],
        total:[Number(results[0][1]),Number(results[0][4])],
        isActive: isActive
      })
    } catch (e) {
      console.log(e)
    }
  }, [address, config])

  useEffect(() => {
    if (config ) {
      fetch()
    } else {
      setValue(null)
    }
  }, [fetch, config, refreshTime]);

  return value
}

export default useW3IDO